<template lang="pug">
.customer-short-detail-button
  button.transparent-button.no-scaling.w-100.d-flex.p-3(
    @click="$emit('click')"
  )
    //- :class='selected ? `selected`:``'
    CustomerPicture(:src='data.image' :grade='data.grade')
    .flex-fill.text-left.ml-3
      .h6.text-secondary.mt-1.mb-1(style="opacity: 0.5;"): small รหัสลูกค้า {{ data.id }}
      .h6.mb-2
        | {{ data.name }}
      .font-weight-normal.text-secondary
        small วงเงินคงเหลือ
      .h5(:class="{'text-danger': data.balance < 0, 'text-secondary': data.balance >= 0}")
        | {{ data.balance | currency }}

  hr.my-0.mx-3

  .d-flex.mx-3
    button.transparent-button.no-scaling.flex-fill.py-2(@click='showPhone')
      i.fa.fa-phone.mr-2
      | เบอร์ติดต่อ
    //- button.transparent-button.no-scaling.flex-fill.py-2
    //-   i.fa.fa-map-marked-alt.mr-2
    //-   | แผนที่
</template>

<script>
import CustomerPicture from './CustomerPicture.vue';

export default {
  props: {
    data: {},
    selected: {
      default: false,
    },
  },
  created() {
    // console.log(this.data);
  },
  methods: {
    showPhone() {
      alert(`เบอร์ติดต่อ: \n${this.data.phone}`);
    },
  },
  components: {
    CustomerPicture,
  },
};
</script>

<style lang="scss">
.customer-short-detail-button {
  width: 100%;
  border-bottom: 1px solid $border-color !important;
  padding: 0;

  // .transparent-button {
  //   &:hover {
  //     transform: scale(1.02)!important;
  //   }
  // }

  .selected {
    color: #fff!important;
  }
}
</style>
